import z from "zod";
import { Constants } from "@/features/shared/constants";
import type { BestillerPrivat } from "../context";

export const translationPrefixPrivatForm = "pages.bestiller.privat.form";

const postnummerSchema = z
  .string()
  .length(4, `${translationPrefixPrivatForm}.feil.postnummer.ugyldig`)
  .regex(/^\d{4,4}$/, `${translationPrefixPrivatForm}.feil.postnummer.ugyldig`)
  .refine(
    (val) => {
      const postnummer = Number(val);
      return !Number.isNaN(postnummer) && postnummer >= 0 && postnummer <= 9999;
    },
    {
      message: `${translationPrefixPrivatForm}.feil.postnummer.ugyldig`,
      path: ["postnummer"],
    },
  );
export const bestillerPrivatFormSchema = z.object({
  boligType: z.enum(Constants.PRIVAT_BOLIGTYPER),
  kundenummer: z
    .string()
    .nonempty(`${translationPrefixPrivatForm}.feil.kundenummer.påkrevd`),
  målerId: z.string().optional(),
  adresse: z
    .string()
    .nonempty(`${translationPrefixPrivatForm}.feil.adresse.påkrevd`),
  postnummer: postnummerSchema,
  poststed: z
    .string()
    .nonempty(`${translationPrefixPrivatForm}.feil.poststed.påkrevd`),
});

export type bestillerPrivatFormValues = z.infer<
  typeof bestillerPrivatFormSchema
>;

export function getDefaultBestillerPrivatFormValues(
  bestillerPrivat: BestillerPrivat | null,
): bestillerPrivatFormValues {
  return {
    boligType: bestillerPrivat?.boligType ?? "Bolig",
    kundenummer: bestillerPrivat?.kundenummer ?? "",
    målerId: bestillerPrivat?.målerId ?? "",
    adresse: bestillerPrivat?.adresse ?? "",
    postnummer: `${bestillerPrivat?.postNummer ?? ""}`,
    poststed: bestillerPrivat?.sted ?? "",
  };
}
